module.exports = __webpack_public_path__ + "static/media/julia.4fcd96da.md";